<template>
  <v-autocomplete
      v-model="value"
      :items="values"
      item-text="name"
      item-value="id"
      :label="label"
      return-object
      hide-details
  />
</template>

<script>
import VueTypes from "vue-types";
import {ShipKind} from "@/modules/redactor/models/trader/ShipKind";

export default {
  name: "r-ship-kind",
  props: {
    model: VueTypes.instanceOf(ShipKind),
    label: VueTypes.string.def("Trader:")
  },
  computed: {
    value: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("update:model", value);
      }
    },
    values() {
      return ShipKind.getValues();
    }
  }
}
</script>